<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Página Não Encontrada</h2>
            <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Página Não Encontrada</li>
            </ul>
        </div>
    </div>

    <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div>
</div>

<div class="error-area ptb-100">
    <div class="error-page">
        <img src="assets/images/404.gif" alt="error" style="width: 240px">
        <h3>Oops! Página Não Encontrada</h3>
        <p>A página que você está buscando nãofoi encontrada em nossos servidores. Pedimos desculpas! Você pode continuar navegando pelos menos ou voltar à nossa página inicial.</p>
        <a routerLink="/" class="box-btn">Home</a>
    </div>
</div>